import React from "react";

export default function NeedsTab() {
    // Dữ liệu chi tiết phiếu nhu cầu theo mảng Clinic
    const needsDetails = [
        { label: "Vấn đề", value: "Da chảy xệ nhẹ vùng má" },
        { label: "Vùng", value: "Mặt" },
        { label: "Đã làm trước", value: "Phác đồ K·Reskin tại Khơ Thị 12/2025" },
        { label: "Mong muốn", value: "Da săn hơn trước Tết" },
        { label: "Lý do làm lúc này", value: "Sự kiện sắp tới — về Việt Nam ăn Tết" },
        { label: "Rào cản", value: "Chỉ ở Việt Nam 3 tuần (15/12 – 05/01)" },
        { label: "Ngân sách khách dự kiến", value: "10.000.000 – 20.000.000 đ" },
        { label: "Thời điểm muốn làm", value: "18/12 – 05/01" },
        { label: "Giờ địa phương", value: "Sydney, nhanh hơn Việt Nam 4 giờ" },
    ];

    return (
        <div className="space-y-3 pt-1 text-xs animate-fade-in text-gray-800 dark:text-gray-200">
            {/* Tiêu đề phiếu nhu cầu */}
            <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm pb-1">
                Phiếu nhu cầu theo mảng Clinic — trường cố định[cite: 16]
            </div>

            {/* Bảng thông tin chi tiết dạng lưới */}
            <div className="bg-slate-50/80 dark:bg-[#252525] p-3 rounded-lg border border-gray-200 dark:border-gray-700 space-y-2">
                {needsDetails.map((item, idx) => (
                    <div key={idx} className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-1 border-b border-gray-100 dark:border-gray-800 last:border-0">
                        <span className="text-gray-500 font-medium">{item.label}</span>
                        <span className="sm:col-span-2 font-semibold text-gray-900 dark:text-gray-100">{item.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}